import React, { Component } from 'react'
import ZodiacSelector from './ZodiacSelector'
import M from 'materialize-css/dist/js/materialize.min.js'
import DailyInputFied from './DailyInputField';
import WeeklyInputField from './WeeklyInputField';
import MonthlyField from './MonthlyField';
import YearInputField from './YearInputField';
import {Daily,Weekly,Monthly,Yearly} from './HoroscopeTypeForms/RequsetHandle'
import {getData3} from '../../Api/Config'

export class HoroscopeForm extends Component {

    state = {
        dateCode:0,
        zodiacId:'0',
        date:'',
        startdate:'',
        endDate:'',
        monthDate:'',
        yearDate:'',
        summary:'',
        health:'',
        business:'',
        career:'',
        family_and_relation:'',
        love_and_relation:'',
        loss:'',
        loan:'',
        vehicle_expenditure:'',
        travel:'',
        auspicious_work:'',
        untoward:'',
        character_quality:'',
        marriage_status:'',
        hobbies:'',
        solution:'',
        lucky_number:'',
        lucky_day:'',
        lucky_gem:'',
        dateError:'',
        zodiacIdError:''
    }

    clearState=()=>{
      this.setState({
        dateCode:0,
        zodiacId:'0',
        date:'',
        startdate:'',
        endDate:'',
        monthDate:'',
        yearDate:'',
        summary:'',
        health:'',
        business:'',
        career:'',
        family_and_relation:'',
        love_and_relation:'',
        loss:'',
        loan:'',
        vehicle_expenditure:'',
        travel:'',
        auspicious_work:'',
        untoward:'',
        character_quality:'',
        marriage_status:'',
        hobbies:'',
        solution:'',
        lucky_number:'',
        lucky_day:'',
        lucky_gem:'',
        dateError:'',
        zodiacIdError:''
      })
    }

    IsValid=()=>{
      let flag = true;
      let {date,startdate,endDate,monthDate,yearDate,zodiacId} = this.state;
      let dateCode = parseInt(this.state.dateCode)
      
      if(zodiacId==='0'){
        this.setState({zodiacIdError:'* zodiac not selected..!'})
        flag=false
      }else{
        this.setState({zodiacIdError:''})
      }

      if(dateCode===0 && date===''){
        this.setState({dateError:'* empty date...!'})
        flag=false
      }

      if(dateCode===1 && (startdate==='' || endDate==='')){
        flag=false
        this.setState({dateError:'* empty date...!'})
      }

      if(dateCode===2 && monthDate===''){
        flag=false
        this.setState({dateError:'* empty date...!'})
      }

      if(dateCode===3 && yearDate===''){
        flag=false
        this.setState({dateError:'* empty date...!'})
      }

      return flag
    }
   
    componentDidMount(){
        var elems = document.querySelectorAll('select');
        M.FormSelect.init(elems, {});
        this.DateUIUpdate = this.DateUIUpdate.bind(this);
    }

    DateUIUpdate(e=null){
        if(e!==null)
            this.setState({dateCode:e.target.value})
    }
    
    UpdateHoroScope=(url,Req)=>{
      getData3(url,Req).then(res=>{
        if(res.ok){
          M.toast({html: "Updated successfully..!"});
          this.props.history.push("/admin/CalendarApp/ViewHoroscope")
        }
      }).catch(err=>{
        M.toast({html: "Error while updating..!"});
        console.log(err);
      })
    }

    handleSubmit=(e)=>{
        e.preventDefault()
        if(this.IsValid()){
          this.setState({dateError:''})
          let url = "https://api.nirmallabs.com/api/v1/calendar/horoscope"
          switch(parseInt(this.state.dateCode)){
            case 0:
                this.UpdateHoroScope(`${url}/daily`,Daily(this.state))
                break;
            case 1:
                this.UpdateHoroScope(`${url}/weekly`,Weekly(this.state))
                break;
            case 2:
                this.UpdateHoroScope(`${url}/monthly`,Monthly(this.state))
                break;    
            case 3:
                this.UpdateHoroScope(`${url}/yearly`,Yearly(this.state))
                break;
            default:
                url+='/daily';
                break;    
          }
        
        }
    }

    handleChange=(e)=>{
      this.setState({[e.target.id]:e.target.value})
    }

    render() {
        const {dateCode} = this.state;
        const dateType = parseInt(dateCode);
        return (
                  <div className="row">
                      <div className="col s12 card hoverable">
                      <p className="red-text"><i className="material-icons left">add</i> HoroscopeForm</p>
                         <div className="card-content">
                         <form className="" onSubmit={this.handleSubmit} autoComplete='off'>
                          <div className="row">
                          <div className="input-field col s6">
                            <ZodiacSelector handleChange={this.handleChange}/>
                          <div style={{fontSize:12 ,color:"red"}}>{this.state.zodiacIdError}</div>

                            </div>  
                            <div className="input-field col s6">
                            <select defaultValue="0" onChange={(e)=>this.DateUIUpdate(e)}>
                             <option value="-1" disabled>Choose date type....</option>
                             <option value='0' >Daily</option>
                             <option value="1" >Weekly</option>
                             <option value="2" >Monthly</option>
                             <option value="3" >Yearly</option>
                             </select>
                            </div>
                          </div>
                          <div className="row"> 
                          {dateType===0 && <DailyInputFied handleChange={this.handleChange} />}
                          {dateType===1 && <WeeklyInputField handleChange={this.handleChange}/>}
                          {dateType===2 && <MonthlyField handleChange={this.handleChange}/>}
                          {dateType===3 && <YearInputField handleChange={this.handleChange}/>}
                          </div>
                          <div className="row">
                          <div style={{fontSize:12 ,color:"red"}}>{this.state.dateError}</div>
                          </div>
                          <div className="row">
                            <div className="input-field col s12">
                                <textarea id="summary" style={{height:100}} onChange={this.handleChange} className="materialize-textarea"></textarea>
                                <label htmlFor="summary">Summary</label>
                            </div>
                          </div> 
                          <div className="row">
                            <div className="input-field col s6">
                            <input  id="health" type="text" onChange={this.handleChange} className="validate"/>
                            <label htmlFor="health">Health</label>
                            </div>

                            <div className="input-field col s6">
                            <input id="business" type="text" onChange={this.handleChange} className="validate"/>
                            <label htmlFor="business">Business</label>
                            </div>
                          </div> 
                          <div className="row">
                            <div className="input-field col s6">
                            <input  id="career" type="text" onChange={this.handleChange} className="validate"/>
                            <label htmlFor="career">Career</label>
                            </div>

                            <div className="input-field col s6">
                            <input id="family_and_relation" onChange={this.handleChange} type="text" className="validate"/>
                            <label htmlFor="family_and_relation">Family And Relation</label>
                            </div>
                          </div> 
                          <div className="row">
                            <div className="input-field col s6">
                            <input  id="love_and_relation" onChange={this.handleChange} type="text" className="validate"/>
                            <label htmlFor="love_and_relation">Love And Relation</label>
                            </div>

                            <div className="input-field col s6">
                            <input id="loss" type="text" onChange={this.handleChange} className="validate"/>
                            <label htmlFor="loss">Loss</label>
                            </div>
                          </div> 
                          <div className="row">
                            <div className="input-field col s6">
                            <input  id="loan" type="text" onChange={this.handleChange} className="validate"/>
                            <label htmlFor="loan">Loan</label>
                            </div>

                            <div className="input-field col s6">
                            <input id="vehicle_expenditure" onChange={this.handleChange} type="text" className="validate"/>
                            <label htmlFor="vehicle_expenditure">Vehicle Expenditure</label>
                            </div>
                          </div> 
                          <div className="row">
                            <div className="input-field col s6">
                            <input  id="travel" type="text" onChange={this.handleChange} className="validate"/>
                            <label htmlFor="travel">Travel</label>
                            </div>

                            <div className="input-field col s6">
                            <input id="auspicious_work" type="text" onChange={this.handleChange} className="validate"/>
                            <label htmlFor="auspicious_work">Auspicious Work</label>
                            </div>
                          </div> 
                          <div className="row">
                            <div className="input-field col s6">
                            <input  id="untoward" type="text" onChange={this.handleChange} className="validate"/>
                            <label htmlFor="untoward">Untoward</label>
                            </div>

                            <div className="input-field col s6">
                            <input id="character_quality" type="text" onChange={this.handleChange} className="validate"/>
                            <label htmlFor="character_quality">Character Quality</label>
                            </div>
                          </div> 
                          <div className="row">
                            <div className="input-field col s6">
                            <input  id="marriage_status" type="text" onChange={this.handleChange} className="validate"/>
                            <label htmlFor="marriage_status">Married Life</label>
                            </div>

                            <div className="input-field col s6">
                            <input id="hobbies" type="text" onChange={this.handleChange} className="validate"/>
                            <label htmlFor="hobbies">Hobbies</label>
                            </div>
                          </div> 
                          <div className="row">
                            <div className="input-field col s6">
                            <input  id="solution" type="text" onChange={this.handleChange} className="validate"/>
                            <label htmlFor="solution">Solution</label>
                            </div>
                            <div className="input-field col s6">
                            <input id="lucky_number" type="text" onChange={this.handleChange} className="validate"/>
                            <label htmlFor="lucky_number">Lucky Number</label>
                            </div>
                          </div> 
                          <div className="row">
                            <div className="input-field col s6">
                            <input  id="lucky_day" type="text" onChange={this.handleChange} className="validate"/>
                            <label htmlFor="lucky_day">Lucky Day</label>
                            </div>

                            <div className="input-field col s6">
                            <input id="lucky_gem" type="text" onChange={this.handleChange} className="validate"/>
                            <label htmlFor="lucky_gem">Lucky Gem</label>
                            </div>
                            <button className="btn btn-small waves-effect waves-light blue-grey" style={{display:'block',margin:'auto'}} type="submit" name="action">Update
                                <i className="material-icons right">send</i>
                            </button>
                          </div> 
                          </form>
                         </div>
                      </div>
                  </div>  

        )
    }
}

export default HoroscopeForm
